import {UPDATE_FILTER_DASHBOARD_TILES, CLEAR_FILTER_DASHBOARD_TILES} from '../actiontypes';

export function updateFilterDashboardTiles(tab, filters) {
	return {
		type: UPDATE_FILTER_DASHBOARD_TILES,
		tab,
		filters
	};
}

export function clearFilterDashboardTiles(tab) {
	return {
		type: CLEAR_FILTER_DASHBOARD_TILES,
		tab
	};
}
